<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import {
  ADMIN_ARTICLES_LIST_ROUTE_NAME,
  AFFILIATE_ARTICLES_LIST_ROUTE_NAME,
  TRANSLATION_GROUP_ADMIN_ARTICLES,
  TRANSLATION_GROUP_AFFILIATE_ARTICLES,
} from '@modules/articles/constants';
import { useArticlesGetQuery } from '@modules/articles/queries';
import { useI18n } from '@modules/i18n/composables';
import { useCurrentNamespace } from '@modules/permissions/composables';
import StaticPagePreview from '@modules/static-pages/components/StaticPagePreview/StaticPagePreview.vue';
import { isString } from '@utils/guards';

const route = useRoute();
const id = computed<number>(() => (
  isString(route.params.id) ? Number(route.params.id) : 0
));

const { getTranslation } = useI18n();
const { data, isLoading } = useArticlesGetQuery(id);

const { isAdminNamespace } = useCurrentNamespace();

const lastUpdateLabel = computed(() => (
  isAdminNamespace.value
    ? getTranslation(TRANSLATION_GROUP_ADMIN_ARTICLES, 'LAST_UPDATE').value
    : getTranslation(TRANSLATION_GROUP_AFFILIATE_ARTICLES, 'LAST_UPDATE').value
));

const backButtonLabel = computed(() => (
  isAdminNamespace.value
    ? getTranslation(TRANSLATION_GROUP_ADMIN_ARTICLES, 'VIEW_BACK').value
    : getTranslation(TRANSLATION_GROUP_AFFILIATE_ARTICLES, 'VIEW_BACK').value
));
</script>

<template>
  <StaticPagePreview v-data-qa-auto-id="'ArticlesViewPage'"
    :is-loading="isLoading"
    :title="data?.title"
    :body="data?.body"
    :last-update="data?.updated_at"
    :last-update-label="lastUpdateLabel"
    :back-button-label="backButtonLabel"
    :back-route="{
      name: isAdminNamespace ? ADMIN_ARTICLES_LIST_ROUTE_NAME : AFFILIATE_ARTICLES_LIST_ROUTE_NAME,
    }"
  />
</template>
